const initialState = {
    details: JSON.parse(localStorage.getItem('quoteHealthDetails')) || null,
};

const quoteHealthDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_QUOTE_HEALTH_DETAILS':
            localStorage.setItem('quoteHealthDetails', JSON.stringify(action.payload));
            return {
                ...state,
                details: action.payload,
            };
        default:
            return state;
    }
};

export default quoteHealthDetailsReducer;